import { render, staticRenderFns } from "./RateProblem.vue?vue&type=template&id=5da5734c&"
import script from "./RateProblem.vue?vue&type=script&lang=js&"
export * from "./RateProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports